import { createSelector } from 'reselect';

import { selectors } from '@api/@slices';

const root = createSelector(selectors.global, (state) => state.workspaceProductsPDFReducer);

export default { root };
